module.exports = __webpack_public_path__ + "img/new-user.07aa4c66.svg";